<template>
  <div id="app">
    <!-- 添加新版本提示 -->
    <div
      class="version-tip"
      v-if="showVersionTip"
    >
      <div
        class="version-tip-content"
        @click="updateVersion"
      >
        <span>发现新版本</span>
        <el-button
          type="text"
          size="small"
          class="update-btn"
          @click="updateVersion"
        >
          点击更新
        </el-button>
      </div>
    </div>
    <div
      v-if="isNews"
      class="news-container"
    >
      <router-view />
    </div>
    <div
      v-else
      class="work-container"
    >
      <div
        class="el-menu-yuanhe"
        v-if="!noHeader"
      >
        <el-menu
          :default-active="activeIndex"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="Home">新增工单</el-menu-item>
          <el-menu-item index="WorkOrderList">我的工单</el-menu-item>
        </el-menu>
      </div>
      <div
        class="container"
        v-if="isDD || (isWeiXin && !isBooking) || isWxSubmit || queryHasDuid || isCustome"
      >
        <keep-alive>
          <!-- 需要缓存的视图组件 -->
          <router-view v-if="$route.meta.keepAlive"> </router-view>
        </keep-alive>

        <!-- 不需要缓存的视图组件 -->
        <router-view v-if="!$route.meta.keepAlive"> </router-view>
      </div>
      <div v-else>请在钉钉内打开此页面</div>
    </div>
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi";
import { isWeiXin } from "@/utils/utils";
import VConsole from "vconsole";
import versionService from "@/apis/version/index.js";
import { CONFIG_STORAGE } from "@/constants/storage.js";

export default {
  data() {
    return {
      activeIndex: "Home",
      isDD: true,
      queryHasDuid: false,
      isWeiXin: isWeiXin(),
      noHeader: false,
      isNews: false,
      isBooking: false,
      isWxSubmit: false,
      isCustome: false,
      showVersionTip: false,
      serverVersion: "",
      localVersion: CONFIG_STORAGE.APP_VERSION,
    };
  },

  watch: {
    $route: {
      handler(newVal) {
        if (
          newVal.path.indexOf("/news") !== -1 ||
          newVal.path.indexOf("/work-order/success") !== -1 ||
          newVal.name == "BookingQrCode" ||
          newVal.name == "SalonTable" ||
          newVal.name == "VaccinumCardDetail" ||
          newVal.name == "allApp" ||
          newVal.name == "AppointmentConfirm" ||
          newVal.name == "ReserveAchievement" ||
          newVal.path.indexOf("/sph") !== -1 ||
          newVal.path.indexOf("/appointment") !== -1 ||
          newVal.path.indexOf("/system") !== -1 ||
          newVal.path.indexOf("/booking") !== -1 ||
          newVal.path.indexOf("/wecom") !== -1 ||
          (newVal.path.indexOf("/reserve") !== -1 &&
            newVal.name !== "ReserveAddWx" &&
            newVal.name !== "ReserveChannel")
        ) {
          this.isNews = true;
        } else {
          this.isNews = false;
        }
        if (newVal.path.indexOf("/customer") !== -1) {
          this.isCustome = true;
        }
        if (newVal.path.indexOf("/booking") !== -1) {
          this.isBooking = true;
        }
        if (newVal.query.duid) {
          this.queryHasDuid = true;
        }
        // 钉钉外提交工单
        if (newVal.name === "Form" && newVal.query.source === "qr") {
          this.isWxSubmit = true;
        } else if (newVal.query.source === "datecenter") {
          this.isWxSubmit = true;
        }
        const currentMenuName = newVal.meta?.parentMenu || newVal.name;
        this.activeIndex = currentMenuName;
        this.noHeader = newVal.meta?.noHeader;
        if (newVal.query.duid) {
          this.noHeader = true;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    let env = "sit";
    if (process.env.NODE_ENV === "production") {
      env = "pro";
    }
    if (window.WebfunnyMonitor) {
      // eslint-disable-next-line no-undef
      WebfunnyMonitor.init({
        projectVersion: "1.0.0", // 应用版本 env: "pro",
        env,
      });
    }

    this.getVersion();
    this.getplatform();
  },
  mounted() {
    setTimeout(() => {
      console.log("debug", this.$route.query.debug);

      if (this.$route.query.debug) {
        new VConsole();
      }
    }, 1000);
  },
  methods: {
    getVersion() {
      const params = {
        app_id: "dingding_order",
      };
      versionService.getVersion(params).then((res) => {
        this.serverVersion = res.app_version;
        // 与本地版本号比较大小
        if (res.app_version > CONFIG_STORAGE.APP_VERSION) {
          // 显示更新提示而不是直接刷新
          this.showVersionTip = true;
        }
      });
    },
    getplatform() {
      // localStorage.setItem("liupl", "true");
      const isDev = localStorage.getItem("liupl");
      if (dd.env.platform === "notInDingTalk" && !isDev) {
        this.isDD = false;
      }
    },
    handleSelect(menu) {
      this.$router.push({
        name: menu,
      });
    },
    updateVersion() {
      // 更新版本
      const url = window.location.href;
      const arr = url.split("?");
      const baseUrl = arr[0];
      const query = arr[1] || "";

      // 解析现有的查询参数
      const searchParams = new URLSearchParams(query);
      // 更新或添加 app_version 参数
      searchParams.set("app_version", this.serverVersion);

      // 强制清除缓存的参数
      searchParams.set("t", Date.now());

      // 构建新的URL
      const newUrl = `${baseUrl}?${searchParams.toString()}`;

      // 强制刷新页面
      window.location.replace(newUrl);
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
#app {
  color: #2c3e50;
  background-color: rgb(238, 241, 249);
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.container {
  // padding: 15px;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.el-menu-yuanhe {
  .el-menu {
    display: flex;
  }
  .el-menu-item {
    flex: 1;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}
.container {
  flex: 1;
  overflow: hidden;
}
.home {
  .el-tabs__nav-prev,
  .el-tabs__nav-next {
    font-size: 28px;
  }
}
.news-container {
  background-color: #fff;
  height: 100%;
  max-width: 700px;
  margin: 0 auto;
  overflow: hidden;
  width: 100%;
}
.work-container {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.version-tip {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(231, 99, 94, 0.1);

  .version-tip-content {
    max-width: 700px;
    margin: 0 auto;
    padding: 8px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #e7635e;

    .update-btn {
      margin-left: 10px;
      color: #e7635e;

      &:hover {
        color: darken(#e7635e, 10%);
      }
    }
  }
}
</style>
